import * as React from "react";

import {Divider, Stack} from "@mui/material";
import styles from "./fileActionBar.module.css";
import CreateNewFolderForm from "../CreateNewFolderForm";
import FileUpload from "../FileUpload";
import useDrive from "../../hooks/useDrive";
import FileAndFolderCopy from "../FileAndFolderCopy";
import {LayoutSwitch} from "../LayoutSwitch";
import {DRIVE_TYPES, PERMISSIONS} from "../../config/appConst";
import {useEffect} from "react";

export default function DriveActionBar() {
    const {CurrentDrive} = useDrive();

    return <div className={styles.buttonContainer}>
        <Stack direction="row-reverse" spacing={1}>
            {
                CurrentDrive.drivePermission === PERMISSIONS.WRITE ? <>
                    <FileUpload parent={CurrentDrive.parent}/>
                    <CreateNewFolderForm parent={CurrentDrive.parent}/>
                    <Divider orientation="vertical" flexItem/></> : ''
            }
            <LayoutSwitch/>
            {
                CurrentDrive.drivePermission === PERMISSIONS.WRITE ? <FileAndFolderCopy/> : ''
            }
        </Stack>
    </div>

}